import { ProductHistorical } from '../../../../../shared/types/systemConfiguration/products';

export interface ProductHistoricalProps {
    historical: ProductHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createdAt: 'Fecha de creación',
    name: 'Nombre',
    active: 'Activo',
    description: 'Descripción',
    code: 'Código',
    applyPqr: 'Aplica Pqr',
    applyEscalations: 'Aplica Escalamiento',
};
